var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('v-flex',[(_vm.loading)?_c('div',[_c('loading')],1):_vm._e(),(_vm.showAlert == true)?_c('div',[_c('alert-empty')],1):_vm._e(),(_vm.dataReady == true)?_c('v-widget',{key:_vm.indexChart,staticClass:"px-0",attrs:{"title":_vm.tituloGraficaRegion,"content-bg":"white"}},[_c('div',{attrs:{"slot":"widget-content"},slot:"widget-content"},[_c('e-chart',{attrs:{"path-option":[
            ['dataset.source', _vm.res],
            [
              'color',
              [_vm.color.lightBlue.base, _vm.color.orange.base, _vm.color.grey.base],
            ],
            ['legend.show', true],
            ['xAxis.axisLabel.show', true],
            ['yAxis.axisLabel.show', true],
            ['grid.left', '2%'],
            ['grid.bottom', '5%'],
            ['grid.right', '3%'],
            //region 1
            ['series[0].type', 'bar'],
            ['series[0].areaStyle', {}],
            ['series[0].smooth', true],
            ['series[1].type', 'bar'],
            ['series[1].areaStyle', {}],
            ['series[1].smooth', true],
            ['series[2].type', 'bar'],
            ['series[2].areaStyle', {}],
            ['series[2].smooth', true],
          ],"height":"400px","width":"100%"}})],1)]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }